import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#clip0_1831_2130)\"><path d=\"M9.74321 9.27441C8.47952 11.1819 6.23274 12.3029 3.95102 12.2119C3.63868 12.2115 3.00524 12.2122 2.69258 12.2119L0.666748 13.9993H9.74321L12.6667 9.27441H9.74321Z\" fill=\"#5EB24A\"></path><path d=\"M4.23019 11.2749C5.88691 11.2792 7.49941 10.5282 8.56644 9.27492H5.99957V4.18617L9.88394 2.36273L5.06207 0.0996094V9.5643L3.53113 11.2749H4.23019Z\" fill=\"#FFE400\"></path></g><defs><clipPath id=\"clip0_1831_2130\"><rect width=\"14\" height=\"14\" fill=\"white\"></rect></clipPath></defs>", 2)
  ])))
}